import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import CategoryComponent from "../components/CategoryComponent";
import '../assets/css/Home.css';

class Categories extends Component {
    render() {
        return (
            <div className="container category-list partner-list">
                <CategoryComponent/>
            </div>
        );
    }
}

export default withAlert()(withRouter(Categories));